import { render } from "./index.vue?vue&type=template&id=0423b457&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0423b457"

export default script